import { useState } from "react";
import { Linkedin, ArrowUpRight, Send, CheckCircle2, AlertCircle } from "lucide-react";
import { profile } from "@/data/profile";

const API = process.env.REACT_APP_BACKEND_URL;

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      const res = await fetch(`${API}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("send failed");
      setStatus("sent");
      setForm({ name: "", email: "", message: "" });
    } catch {
      setStatus("error");
    }
  };

  return (
    <section className="section contact-section" id="contact">
      <div className="container contact-inner">
        <p className="eyebrow">08 · Connect</p>
        <h2 className="contact-title" data-testid="contact-heading">
          Let's build something <em>meaningful</em> together.
        </h2>
        <p className="body-text contact-sub">
          Whether it's financial literacy, education, or public service, I'm always open to new conversations and collaborations.
        </p>
        <div className="contact-grid">
          <form className="contact-form" onSubmit={handleSubmit} data-testid="contact-form">
            <div className="form-row">
              <input
                type="text"
                placeholder="Your name"
                value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                required
                maxLength={120}
                data-testid="contact-name-input"
              />
              <input
                type="email"
                placeholder="Your email"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                required
                data-testid="contact-email-input"
              />
            </div>
            <textarea
              placeholder="Your message"
              rows={4}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              required
              maxLength={4000}
              data-testid="contact-message-input"
            />
            <button type="submit" className="contact-cta" disabled={status === "sending"} data-testid="contact-submit-button">
              <Send size={16} /> {status === "sending" ? "Sending..." : "Send message"}
            </button>
            {status === "sent" && (
              <p className="form-status form-success" data-testid="contact-success-message">
                <CheckCircle2 size={15} /> Message sent. Thank you for reaching out!
              </p>
            )}
            {status === "error" && (
              <p className="form-status form-error" data-testid="contact-error-message">
                <AlertCircle size={15} /> Something went wrong. Please try again or reach out on LinkedIn.
              </p>
            )}
          </form>
          <div className="contact-side">
            <p className="contact-side-label">Or find me on</p>
            <a
              href={profile.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="contact-linkedin"
              data-testid="contact-linkedin-button"
            >
              <Linkedin size={18} /> LinkedIn <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
        <footer className="footer" data-testid="footer">
          <span>© {new Date().getFullYear()} Arjan Bajwa</span>
          <span className="footer-motto">{profile.motto}</span>
        </footer>
      </div>
    </section>
  );
};
